import React from 'react'
import { useNotificationListContext } from './Context'
import { MenuHeaderCell } from '../../DataTable/table-header/MenuHeaderCell'
import { CheckboxHeaderCell } from '../../DataTable/table-header/CheckboxHeaderCell'
import type { HeaderRowConfig } from '../../DataTable/types'

export const ListHeader = (props: HeaderRowConfig) => {
  const listContext = useNotificationListContext()
  const { toggleSelectAll, hasSelectedAll } = listContext.notificationListWithSelection
  return (
    <>
      <MenuHeaderCell />

      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />

      {props._renderDataHeaderCell()}
    </>
  )
}
